// extracted by mini-css-extract-plugin
export default {"graphContainer":"BarGraph_graphContainer__hIflc","sideText":"BarGraph_sideText__Z67Yu","bottomText":"BarGraph_bottomText__B+NU4"};